import { ModalFooterButton } from '@/components/Modal'

import { useTexts } from '../../../useTexts'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useController } from '../../../hooks/useController'

export function ButtonDelete() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const {
    data: { canDeleteOrders },
  } = useController()

  return (
    <ModalFooterButton
      testid="modal-primary-button"
      title={texts.buttonDelete}
      color="error"
      onClick={handlers.onDeleteButtonClick}
      disabled={!canDeleteOrders}
    >
      {texts.buttonDelete}
    </ModalFooterButton>
  )
}
